import {
	ActionStatus,
	ActionStatusClient,
	ClientSegmentType,
	MessageFilterType,
} from './clientDirectory';

export type OrderByCaseClients =
	| 'STATUS_DATE_ASC'
	| 'STATUS_DATE_DESC'
	| 'NAME_ASC'
	| 'NAME_DESC'
	| 'MESSAGES_REPLIED_TO_UNREAD'
	| 'MESSAGES_UNREAD_TO_REPLIED';

export type StatusCaseClients = 'Complete' | 'Review' | 'Pending' | 'Rejected';

export const StatusCaseClientsMap: Record<string, StatusCaseClients> = {
	complete: 'Complete',
	review: 'Review',
	pending: 'Pending',
	rejected: 'Rejected',
};

export interface BaseCaseFilters {
	search?: string | null;
	orderBy?: OrderByCaseClients | null;
	status?: StatusCaseClients | null;
	messageFilter?: MessageFilterType | string | null;
	start_date?: string | null;
	end_date?: string | null;
	questions?: {
		questionId: number;
		answers: string[];
	}[];
	claimFormQuestions?: {
		questionId: number;
		answers: string[];
	}[];
	stepperStatusIds?: number[];
	stateIds?: number[];
	flagged?: boolean | null;
	flagged_reasons?: string[] | null;
	documents?: string[];
}

export interface CaseClientsRequest extends BaseCaseFilters {
	page: number;
	limit?: number;
	clientId?: string | null;
	segmentId?: string | null;
	isOrderAlph?: boolean;
	caseId: string | null;
	totalCase?: string | null;
	totalTaskClient?: string | null;
	totalTaskLawyer?: string | null;
	actionStatusLawyer?: string;
	actionStatusClient?: string;
	totalMessage?: string;
}

export interface ExportCsvRequest extends BaseCaseFilters {
	caseId: string;
	name?: string;
	clientId?: string;
	users_ids?: string[];
	segmentId?: string[];
	isOrderAlph?: boolean;
	actionStatusLawyer?: string;
	actionStatusClient?: string;
	totalCase?: number;
	totalTaskClient?: number;
	totalTaskLawyer?: number;
	totalMessage?: number;
	withName: boolean;
	withEmail: boolean;
	withPhone: boolean;
	withAddress: boolean;
	withStep: boolean;
	withStatus: boolean;
	withDate: boolean;
	withFollowUp: boolean;
}

export interface CaseClientsResponse {
	items: CaseClientItem[];
	total: number;
	totalPages: number;
	totalItems: number;
	page: number;
	limit: number;
	counters: CaseClientsCounter;
}

export interface CaseClientsCounter {
	all: number;
	complete: number;
	pending: number;
	review: number;
	rejected: number;
	total: number;
}

export interface CaseClientItem {
	user_id: string;
	application_id: number;
	profile_picture: string | null;
	first_name: string | null;
	last_name: string | null;
	lawyer_tasks: number;
	client_tasks: number;
	lawyer_action_status_array: ActionStatus[] | null;
	client_task_status: ActionStatusClient | null;
	total_messages: number;
	has_unread_messages: boolean;
	has_new_messages: boolean;
	segmentation: ClientSegmentType | null;
	stepper_status: string | null;
	status: StatusCaseClients;
	progress_status: string | null;
	isActive?: boolean;
	status_date: string | null;
	flagged: boolean;
	flagged_reason: string[] | null;
}

export interface FlagReason {
	id: number;
	name: string;
	is_custom: boolean;
	description?: string | null;
}

export interface FlagReasonWithCount extends FlagReason {
	flagged_clients: number;
}
